export enum AuditLogUserUpdateReasonType {
  UserRequested = 8,
  InvalidData = 9,
}

export const AuditLogUserUpdateReasonTypeMapping = [
  { text: 'User Requested', value: AuditLogUserUpdateReasonType.UserRequested },
  { text: 'Invalid Data', value: AuditLogUserUpdateReasonType.InvalidData },
];
